/* dilla-editorial.js
   Sticky CTA controller for Dilla advertorial + listicle sections.
   Reveals a [data-dilla-sticky] bar once the hero has scrolled out of view,
   and hides it again when the final CTA enters view. One observer per target;
   safe against the asset being included more than once per page. */
(function () {
  if (window.__dillaEditorialInit) return;
  window.__dillaEditorialInit = true;

  function init() {
    var bars = document.querySelectorAll('[data-dilla-sticky]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var hero = document.querySelector(bar.getAttribute('data-hero'));
      var end = document.querySelector(bar.getAttribute('data-end'));
      if (!hero) return;

      var heroVisible = true;
      var endVisible = false;

      function update() {
        if (!heroVisible && !endVisible) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { heroVisible = e.isIntersecting; });
          update();
        }, { threshold: 0 }).observe(hero);

        if (end) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { endVisible = e.isIntersecting; });
            update();
          }, { threshold: 0 }).observe(end);
        }
      } else {
        // Fallback: reveal after scrolling past the hero.
        window.addEventListener('scroll', function () {
          var past = (window.pageYOffset || document.documentElement.scrollTop) > (hero.offsetTop + hero.offsetHeight);
          heroVisible = !past;
          update();
        }, { passive: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
